// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__W1AvC","colMin":"styles_colMin__d_fjQ"};